/*
 * Copyright (c) 2022 automata-network/tgb-donation authors and contributors.
 * This software may be modified and distributed under the terms of MIT license.
 * Refer to the LICENSE file for details.
 */
import BigNumberJS from 'bignumber.js'

import { CouldBe } from '../types/main'

// Return the formatted amount with decimal up to 5 places
// and also remove trailing zeros from the decimals if any.
// For example: 1234.56000 -> 1,234.56
export const formatCouponAmountToString = (amount: CouldBe<BigNumberJS>) => {
  if (!amount) return

  return amount
    .toFormat(5, BigNumberJS.ROUND_DOWN, {
      groupSize: 3,
      groupSeparator: ',',
      decimalSeparator: '.'
    })
    .replace(/\.?0*$/, '')
}

export const getBalanceOfCoupon = async () => {}
